
/**
 * @typedef {Object} ReasonBreakdown
 * @property {number} totalSubmissions
 * @property {Array<{id: string, label: string, count: number, submissions: number, subReasons: Array<{id: string, label: string, count: number}>}>} categories
 */

/**
 * @param {ReasonBreakdown} breakdown
 * @return {number}
 */
export function totalSelections(breakdown) {
  return (breakdown?.categories || []).reduce((sum, c) => sum + c.count, 0)
}

/**
 * @param {{subReasons: Array<{id: string, label: string, count: number}>}} category
 * @return {Array<{id: string, label: string, value: number, count: number}>}
 */
export function subReasonPercentages(category) {
  const total = (category?.subReasons || []).reduce((sum, s) => sum + s.count, 0)
  return (category?.subReasons || []).map(s => ({
    id: s.id,
    label: s.label,
    count: s.count,
    value: total > 0 ? Math.round((s.count / total) * 100) : 0,
  }))
}
